import { tickerList } from "@/mocks/feed";

export default function Ticker() {
  const doubled = [...tickerList, ...tickerList];
  return (
    <div className="border-y border-background-200 bg-foreground-950">
      <div className="mx-auto flex max-w-[1320px] items-center px-4 md:px-6">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-accent-500 px-3 py-2.5 text-background-50">
          <i className="ri-radar-line text-sm" aria-hidden="true"></i>
          <span className="whitespace-nowrap text-xs font-bold uppercase tracking-widest">快讯流</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-2.5 pl-3">
          <div className="ticker-track flex w-max items-center gap-10">
            {doubled.map((item, i) => (
              <span
                key={i}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-background-100/90"
              >
                <i className="ri-arrow-right-s-line text-accent-400" aria-hidden="true"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}